import React, { useState, useEffect, useRef } from 'react';
import Form from 'antd/lib/form';
import Input from 'antd/lib/input';
import Button from 'antd/lib/button';
import Divider from 'antd/lib/divider';
import { Link } from 'react-router-dom';
import { forgotPassword } from '../../API';
import { config } from '../../config';

import lightVars from '../../light.json';
import darkVars from '../../dark.json';
import './ForgotPassword.less';

// ICONS
import logoLight from '../../icons/parity-logo-light.svg';
import logoDark from '../../icons/parity-logo-dark.svg';

// IMAGES

const { REACT_APP_BUILD_ENV } = config;

async function submitForgotPassword(email) {
  const response = await forgotPassword(REACT_APP_BUILD_ENV, email, window.location.origin);

  return response;
}

const ForgotPassword = () => {
  const [theme, setTheme] = useState('');
  const [email, setEmail] = useState('');
  const [showForgotPasswordConfirm, setShowForgotPasswordConfirm] = useState(false);
  const forgotPasswordEmailRef = useRef(null);

  useEffect(() => {
    const getCurrentTheme = () => {
      const currentTheme = localStorage.getItem('theme-name');

      if (currentTheme === 'light') {
        localStorage.setItem('app-theme', JSON.stringify(lightVars));
        window.less.modifyVars(lightVars);
        setTheme(currentTheme);
      } else if (currentTheme === 'dark') {
        localStorage.setItem('app-theme', JSON.stringify(darkVars));
        window.less.modifyVars(darkVars);
        setTheme(currentTheme);
      } else {
        localStorage.setItem('theme-name', 'light');
        localStorage.setItem('app-theme', JSON.stringify(lightVars));
        window.less.modifyVars(lightVars);
        setTheme('light');
      }
    };

    getCurrentTheme();
    forgotPasswordEmailRef.current.focus();
  }, []);

  return (
    <div className={`forgot-password forgot-password-${theme}`}>
      <div className="forgot-password-spacer" />
      {showForgotPasswordConfirm ? (
        <div className="forgot-password-content">
          <div className="forgot-password-card">
            <div className="forgot-password-card-reset__content">
              {theme === 'light' ? (
                <img className="forgot-password-card__logo" src={logoLight} alt="Parity" />
              ) : (
                <img className="forgot-password-card__logo" src={logoDark} alt="Parity" />
              )}
              <div className="forgot-password-card-reset__title">Password reset link sent!</div>
              <div className="forgot-password-card-reset__text top">
                {`Instructions for resetting your password have been sent to `}
                {email}
              </div>
              <div className="forgot-password-card-reset__text bottom">
                You&apos;ll receive this email within 5 minutes. Be sure to check your spam folder, too
              </div>
              <Divider className="forgot-password__divider" />
              <Link to="/login" className="forgot-password_link">
                Back to sign in
              </Link>
            </div>
          </div>
        </div>
      ) : (
        <div className="forgot-password-content">
          <div className="forgot-password-card">
            <div className="forgot-password-card__content">
              {theme === 'light' ? (
                <img className="forgot-password-card__logo" src={logoLight} alt="Parity" />
              ) : (
                <img className="forgot-password-card__logo" src={logoDark} alt="Parity" />
              )}
              <div className="forgot-password-card__title">Recover your account</div>
              <div className="forgot-password-card__text-wrapper">
                Enter your e-mail and we&apos;ll send you a link to get back into your account
              </div>
              <Form
                layout="vertical"
                className={`forgot-password-card__form app-form-${theme}`}
                onFinish={() => setShowForgotPasswordConfirm(submitForgotPassword(email))}
              >
                <Form.Item
                  name="email"
                  label="E-mail"
                  className="forgot-password__input-wrapper"
                  rules={[
                    {
                      type: 'email',
                      message: 'This is not a valid e-mail',
                    },
                    {
                      required: true,
                      message: 'Please enter your e-mail',
                    },
                  ]}
                  hasFeedback
                >
                  <Input
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    size="large"
                    className="forgot-password__input"
                    ref={forgotPasswordEmailRef}
                  />
                </Form.Item>
                <div className="forgot-password__button-wrapper">
                  <Button block htmlType="submit" size="large" className="forgot-password__button">
                    <div className="forgot-password__button-text">Send reset link</div>
                  </Button>
                </div>
              </Form>
              <div className="forgot-password__signup-text">
                <div>Don&apos;t have an account? </div>
                <Link to="/signup" className="forgot-password__signup-text--blue">
                  Sign up
                </Link>
              </div>
              <Divider className="forgot-password__divider" />
              <Link to="/login" className="forgot-password_link">
                Back to sign in
              </Link>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ForgotPassword;
